// components/Header.jsx
import React from "react";

export default function Header() {
  return (
    <header className="    top-0 left-0 w-full z-50 bg-[#131758]">
      <div className="max-w-screen-xl mx-auto px-4 py-7 flex items-center">
        <img
          src="/logo.png"
          alt="Jakarta Aquarium Safari"
          className="h-10"
        />
      </div>
    </header>
  );
}
